import { z } from 'zod';

export function parseCsvString<T>(
  csvContent: string,
  schema: z.ZodType<T>,
): Promise<T[]> {
  return new Promise((resolve, reject) => {
    try {
      const lines = csvContent.trim().split('\n');
      const headers = lines[0].split(',').map((header) => header.trim());
      const results: T[] = [];

      for (let i = 1; i < lines.length; i++) {
        const values = lines[i].split(',').map((value) => value.trim());
        const row: Record<string, string> = {};

        headers.forEach((header, index) => {
          row[header] = values[index];
        });

        try {
          const parsedData = schema.parse(row);
          results.push(parsedData);
        } catch (error) {
          console.error(`Error parsing row ${i + 1}:`, error);
          // Optionally, you can choose to reject here if you want to stop on first error
          // reject(error);
        }
      }

      resolve(results);
    } catch (error) {
      reject(error);
    }
  });
}
